const DATA_URL = '/spruch-des-tages.json';

// Day number in local time, used to rotate entries without a date.
const dayNumber = () => {
  const d = new Date();
  return Math.floor(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()) / 86400000);
};

// Today as "DD-MM" in local time; independent of the year.
const todayKey = () => {
  const d = new Date();
  const pad = (n) => String(n).padStart(2, '0');
  return `${pad(d.getDate())}-${pad(d.getMonth() + 1)}`;
};

// Tolerates "2-5" or "02-05" in the JSON file.
const normalizeDate = (value) => {
  const m = /^\s*(\d{1,2})-(\d{1,2})\s*$/.exec(value || '');
  return m ? `${m[1].padStart(2, '0')}-${m[2].padStart(2, '0')}` : null;
};

const pickEntry = (sayings) => {
  const today = todayKey();
  const matches = sayings.filter((s) => normalizeDate(s.date) === today);
  if (matches.length) return matches[Math.floor(Math.random() * matches.length)];

  const undated = sayings.filter((s) => !normalizeDate(s.date));
  return undated.length ? undated[dayNumber() % undated.length] : null;
};

class SayingOfTheDay extends HTMLElement {
  async connectedCallback() {
    try {
      const response = await fetch(this.dataset.src || DATA_URL);
      const sayings = await response.json();
      if (!Array.isArray(sayings)) return;
      const entry = pickEntry(sayings);
      if (entry) this.render(entry);
    } catch (e) {
      console.error('Spruch des Tages konnte nicht geladen werden', e);
    }
  }

  render({ title = '', text = '', url = '' }) {
    // title and text are trusted, hand-maintained HTML from the JSON file.
    const link = (content, cls = '') => (url ? `<a ${cls ? `class="${cls}" ` : ''}href="${url}">${content}</a>` : content);
    this.innerHTML = `
      <article class="col-6 featured-post saying-of-the-day">
        ${url
          ? `<a class="featured-post__image" href="${url}" aria-hidden="true" tabindex="-1"><span>💬</span></a>`
          : '<span class="featured-post__image"><span>💬</span></span>'}
        <div>
          <span class="saying-of-the-day__label">Spruch des Tages</span>
          <h3>${link(title)}</h3>
          <p>${text}</p>
          ${url ? `<p><a class="featured-link" href="${url}">Mehr dazu</a></p>` : ''}
        </div>
      </article>`;
  }
}

customElements.define('saying-of-the-day', SayingOfTheDay);
